import { render, staticRenderFns } from "./OrderBoxItem.vue?vue&type=template&id=5596bac4&"
import script from "./OrderBoxItem.vue?vue&type=script&lang=js&"
export * from "./OrderBoxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports